import React, { Component } from 'react';
import {Button, Row, Icon, Drawer, Switch, Popover, Alert} from 'antd';
import { Link } from 'react-router-dom';
import axios  from 'axios';
import { Calendar , FullCalendar} from '@fullcalendar/core';
import interactionPlugin from '@fullcalendar/interaction';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import KnowMoreDrawer from './KnowMoreDrawer'
import '@fullcalendar/core/main.css';
import '@fullcalendar/daygrid/main.css';
import '@fullcalendar/timegrid/main.css';
import '@fullcalendar/list/main.css';
import { SALES_ROLE } from '../../constants/overview';

class CalendarComp extends Component {
  constructor(props) {

    super(props);
      this.state = {
        events: [],
        overviewEventId: '0',
        showKnowMoreModal: false,
        visible: false,
        clicked: false,
        calendar_url: sessionStorage.getItem('calendar_url')
      };

  }

  componentDidMount () {
    let key = ( !this.props.location.state || this.props.location.state.overviewEventId === null || this.props.location.state.overviewEventId === '' ) ? '0' : this.props.location.state.overviewEventId
    this.setState({overviewEventId: key})
    this.fetchEvents()
  }

  handleVisibleChange = (visible) => {
    this.setState({
      clicked: visible
    });
  }

  updateEvents(e) {
    let that = this
    var calendarEl = document.getElementById('fullcalendar');
    var calendar = new Calendar(calendarEl, {
      plugins: [ interactionPlugin, dayGridPlugin, timeGridPlugin, listPlugin ],
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
      },
      defaultDate: Date.now(),

      navLinks: true, // can click day/week names to navigate views
      editable: false,
      eventLimit: true, // allow "more" link when too many events
      events: e,
      eventClick: function(info) {
        {that.showEvent(info.event.id)};
      },
      eventTimeFormat: { // like '14:30:00'
        hour: '2-digit',
        minute: '2-digit'
      }
    });


    calendar.render();
  }

  fetchEvents = () =>{
  let that = this
    let url = window.API_URL + "corporate/events/all_events"
    window.axios.get(url)
    .then(function (response){
      that.setState({events: response.data.events},that.updateEvents(response.data.events))
      if(that.state.overviewEventId != '0') { that.showEvent(that.state.overviewEventId) }
      that.props.location.state = ''  
    })
    .catch(function (error){
      console.log(error);
    })
    
  }

  updateEvent = () => {
    this.setState({
      visible: false,
      showKnowMoreModal: false
    });
    var list = document.getElementById("fullcalendar");
    while (list.hasChildNodes()) {
      list.removeChild(list.firstChild)
    } 
    this.fetchEvents()
  }

  showEvent = (id) => {
    this.setState({ visible: true, event_id: id,showKnowMoreModal: true })
  }

  handleCancel = (e) => {
    this.setState({
      visible: false,
      showKnowMoreModal: false
    });
  }

  handleClose = (e) => {
    this.setState({
      visible: false,
      showKnowMoreModal: false
    });
      
  }

  cancelModal(e){
    this.setState({showKnowMoreModal: false})
  }

  renderModal(){
    if (this.state.showKnowMoreModal) {
      return(<Drawer
        width={'30%'}
        visible={this.state.visible}
        onCancel={this.handleCancel}
        onClose={this.handleClose}
        footer={null}
        >
        <KnowMoreDrawer visible={this.state.showKnowMoreModal} 
                        eventId={this.state.event_id}
                        postUpdate={this.updateEvent}
                        closeModal={this.cancelModal.bind(this)}/>
        </Drawer>
      )  
    } else {
      return(<div/>)
    }
  }

  viewAllEvents(){
    this.props.history.push('/events') 
  }

  onChange(checked) {
    if (checked === true) {
      window.open('webcal://localhost:3000/v1/corporate/events/sync_calendar.ics')
    }
  }

  copyCalendarUrl() {
    let textarea = document.createElement('textarea');
    textarea.id = 't'
    textarea.style.height = 0
    document.body.appendChild(textarea)
    textarea.value = document.getElementById("copy_calendar_url").innerText
    let selector = document.querySelector('#t')
    selector.select()
    document.execCommand('copy')
    alert("Ekincare calendar URL copied")
    document.body.removeChild(textarea)
  }

  renderCreateEvent(){
    this.props.history.push('/wellness-calendar/create-event') 
  }
 
  render(){
    const clickContent = (<div id="copy_calendar_url" className="truncate-text-url"> {this.state.calendar_url} </div>);
    return (
      <div style={{paddingTop: 20}}>
        <Row type='flex' justify='end'>
        {this.state.clicked && !(SALES_ROLE === 'sales') ? 
        <Alert message="We will try to open your default calendar when you click on 'Open Calendar' and will add these events. In case the default calendar doesn't open please use 'copy' option to copy the calendar URL, where you can sync these events to your calendar manually. " type="info" banner />
         : null}
        
        <Popover
          content={(<div>
                      {clickContent}
                      
                      <Row type='flex' justify='end'>
                        <a style={{marginLeft: 20}} href={this.state.calendar_url}>Open Calendar</a>
                        <a style={{marginLeft: 20}} onClick={this.copyCalendarUrl}>Copy</a>
                      </Row>
                    </div>)}
          title="Calendar URL"
          trigger="click"
          visible={this.state.clicked && !(SALES_ROLE === 'sales')}
          onVisibleChange={this.handleVisibleChange}
          placement="bottom"
        >          
          <Button type="default" disabled={SALES_ROLE === 'sales'}><Icon type="sync" />Sync Calendar</Button></Popover>
          <Button type="default" style={{marginLeft: 20}}><Link type="primary" to="/wellness-calendar/events">View Events</Link></Button>
          <Button type="primary" style={{marginLeft: 20}} icon="plus" onClick={this.renderCreateEvent.bind(this)}>Create Event</Button>
        </Row>
        <div id='fullcalendar' style={{paddingTop: 20}}>
        </div>
      {this.renderModal()} 
      </div>


    )
  
  }
}
export default CalendarComp;